// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3fBwC","buttons":"RemoveExpirationActionButtons_buttons__3C4kF"};